import { defineMessages } from 'react-intl';

export default defineMessages({
  linkText: {
    id: 'consentBanner.linkText',
    defaultMessage: 'Privacy and Cookie Policy',
  },
  bannerText: {
    id: 'consentBanner.bannerText',
    defaultMessage:
      '{siteName} uses cookies to store data such as your country of residence and travel dates. We use ' +
      'data for marketing in accordance with the European General Data Protection Regulation (GDPR). See our ' +
      '{link} for more information. By clicking ‘ACCEPT’ you consent to us using your data.',
  },
  acceptButtonText: {
    id: 'consentBanner.acceptButtonText',
    defaultMessage: 'Accept',
  },
});
